import { render, staticRenderFns } from "./AppSupportIcon.vue?vue&type=template&id=54cd5d8e"
import script from "./AppSupportIcon.vue?vue&type=script&lang=js"
export * from "./AppSupportIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports